<template>
  <button class="primary-button pa2 pl3 pr3 bg-blue bn pointer white f3">
    <slot></slot>
  </button>
</template>

<script>

export default {
  name: 'content-card',
  data() {
    return {
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// PrimaryButton.vue?4be0bfa2